import React from 'react';
import {Provider, connect} from 'react-redux';

import EyeInTheSky from "./EyeInTheSky";
import {getReduxStore} from "../ReduxStore/store";
import EyeInTheSkyStartupWrapper from "./EyeInTheSkyStartupWrapper";

/**
 * 2022-08 MH - this invisible component, in the page header, watches
 * everything in Redux. Its children can subscribe to various properties
 * and take action when something changes.
 */

function mapStateToProps(state) {
  const {scrapyardSlice = {}, navigationSlice={}, vehicleSlice = {}, railsContext = {}, userStore={}} = state;

  // FIXME: using deprecated name for cartStore
  const cartStore = state.cartStore || state.cart || {};

  let props = Object.assign({},
    scrapyardSlice, // promote to top level
    {railsContext, userStore, navigationSlice},
    _.pick(vehicleSlice, 'customerVehicle'),
    _.pick(cartStore, 'shoppingCart')
  );
  props.cartSlice ||= state.cart; // badly named slice.

  return props;
}

let Wrapper = connect(mapStateToProps)(EyeInTheSkyStartupWrapper);

export default function EyeInTheSkyApp({...props}) {
  return <Provider store={getReduxStore()}>
    <Wrapper {...props} />
  </Provider>
}
